// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.BookingDetailsContent_booking__d6Btn {
  width: 100%;
  max-width: 1100px;
  font-family: "Sora", sans-serif;
  color: #13231D;
}
.BookingDetailsContent_booking__info-column__uo8pZ {
  display: flex;
  flex-direction: column;
  gap: 24px;
  transition: transform 0.2s ease;
}
.BookingDetailsContent_booking__info-column__uo8pZ:hover {
  transform: translateY(-1px);
}
.BookingDetailsContent_booking__header__roH01 {
  margin-bottom: 28px;
}
.BookingDetailsContent_booking__sidebar__OKSJS:hover {
  transform: translateY(-1px);
}
.BookingDetailsContent_booking__eyebrow__VflTP {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #82B194;
  margin-bottom: 8px;
}
.BookingDetailsContent_booking__title__ABCbI {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.04em;
  margin: 0;
}
.BookingDetailsContent_booking__subtitle__ciDr6 {
  font-size: 16px;
  color: rgba(19, 35, 29, 0.68);
  margin-top: 8px;
}
.BookingDetailsContent_booking__divider__M9jWO {
  height: 1px;
  background-color: rgba(16, 25, 21, 0.08);
  border: none;
  margin: 32px 0;
}
.BookingDetailsContent_booking__grid__N5fdQ {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 24px;
}
@media (max-width: 992px) {
  .BookingDetailsContent_booking__grid__N5fdQ {
    grid-template-columns: 1fr;
  }
}
.BookingDetailsContent_booking__card__n4DAl {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  height: 420px;
}
@media (max-width: 992px) {
  .BookingDetailsContent_booking__card__n4DAl {
    height: auto;
  }
}
.BookingDetailsContent_booking__reminder__lehol {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  background: rgba(130, 177, 148, 0.1);
  border: 1px solid rgba(130, 177, 148, 0.24);
  border-radius: 16px;
  color: #32453b;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  margin-bottom: 24px;
  align-items: center;
}
.BookingDetailsContent_booking__reminder__lehol svg {
  color: #82B194;
  flex-shrink: 0;
}

.BookingDetailsContent_info-grid__gkJOS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
@media (max-width: 600px) {
  .BookingDetailsContent_info-grid__gkJOS {
    grid-template-columns: 1fr;
  }
}

.BookingDetailsContent_info-item__label__PRvfR {
  display: block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6B8277;
  margin-bottom: 8px;
}
.BookingDetailsContent_info-item__value__ABMVR {
  font-size: 16px;
  font-weight: 600;
  color: #13231D;
  margin: 0;
}
.BookingDetailsContent_info-item__view-btn__Z0eII {
  text-decoration: none;
  color: #82B194;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
}
.BookingDetailsContent_info-item__view-btn__Z0eII:hover {
  text-decoration: underline;
}
.BookingDetailsContent_info-item__more-btn__wh3ka {
  text-decoration: none;
  color: #82B194;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
}
.BookingDetailsContent_info-item__more-btn__wh3ka:hover {
  text-decoration: underline;
}
.BookingDetailsContent_info-item__view-btn__Z0eII, .BookingDetailsContent_info-item__more-btn__wh3ka {
  background: none;
  border: none;
  color: #82B194;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
}
.BookingDetailsContent_info-item__view-btn__Z0eII:hover, .BookingDetailsContent_info-item__more-btn__wh3ka:hover {
  text-decoration: underline;
}

.BookingDetailsContent_notes-section__YJvcF {
  margin-top: 24px;
}

.BookingDetailsContent_notes-display__text__qiYQs {
  font-size: 15px;
  line-height: 1.6;
  color: #13231D;
  margin-bottom: 8px;
}
.BookingDetailsContent_notes-display__text--empty__AK1TB {
  font-style: italic;
  color: rgba(19, 35, 29, 0.68);
  opacity: 0.7;
}
.BookingDetailsContent_notes-display__edit__YO3OC {
  font-size: 13px;
  font-weight: 800;
  color: #82B194;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.BookingDetailsContent_notes-editor__input__4\\+Rha {
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  font-family: inherit;
  font-size: 14px;
  outline: none;
}
.BookingDetailsContent_notes-editor__input__4\\+Rha:focus {
  border-color: #82B194;
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.1);
}
.BookingDetailsContent_notes-editor__buttons__FCK5x {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BookingDetailsContent_notes-editor__actions__tJG5Q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.BookingDetailsContent_notes-editor__meet__bqhyk {
  font-size: 13px;
  font-weight: 800;
  color: #82B194;
  background: #fff;
  border: 1px solid #82B194;
  padding: 6px 12px;
  border-radius: 10px;
  cursor: pointer;
}
.BookingDetailsContent_notes-editor__btn--save__3jK9o {
  background: #82B194;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 12px;
  font-weight: 800;
  cursor: pointer;
}
.BookingDetailsContent_notes-editor__btn--cancel__TxKBH {
  background: none;
  border: none;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 700;
  margin-right: 12px;
  cursor: pointer;
}

.BookingDetailsContent_professional-card__6WhhS {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.BookingDetailsContent_professional-card__info__9hzjO {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.BookingDetailsContent_professional-card__avatar-frame__\\+YgZd {
  width: 176px;
  aspect-ratio: 4/5;
  border-radius: 30px;
  padding: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);
  margin-bottom: 20px;
  position: relative;
}
.BookingDetailsContent_professional-card__img-container__it2c- {
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background-color: #F1EEE8;
  background-size: cover;
  background-position: center;
}
.BookingDetailsContent_professional-card__name__GRuAn {
  font-size: 22px;
  font-weight: 800;
  margin: 0;
}
.BookingDetailsContent_professional-card__specialty__hFaPC {
  font-size: 14px;
  color: #82B194;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 4px 0 24px;
}

.BookingDetailsContent_booking__status-wrapper__x1r4m {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/BookingDetails/BookingDetailsContent.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACI,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,cDUmB;ACDvB;AAPI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;AASR;AAPQ;EACI,2BAAA;AASZ;AALI;EACI,mBAAA;AAOR;AAIQ;EACI,2BAAA;AAFZ;AAMI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cDvCe;ECwCf,kBAAA;AAJR;AAOI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AALR;AAQI;EACI,eAAA;EACA,6BDrCe;ECsCf,eAAA;AANR;AASI;EACI,WAAA;EACA,wCDhDe;ECiDf,YAAA;EACA,cAAA;AAPR;AAUI;EACI,aAAA;EACA,gCAAA;EACA,SAAA;AARR;AAUQ;EALJ;IAMQ,0BAAA;EAPV;AACF;AAUI;EACI,mBDlEe;ECmEf,wCAAA;EACA,mBDrCQ;ECsCR,aAAA;EACA,2CDvBM;ECwBN,aAAA;AARR;AAUQ;EARJ;IASQ,YAAA;EAPV;AACF;AAUI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AARR;AAUQ;EACI,cDrGW;ECsGX,cAAA;AARZ;;AAaA;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAVJ;AAYI;EALJ;IAMQ,0BAAA;EATN;AACF;;AAaI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAVR;AAcI;EACI,eAAA;EACA,gBAAA;EACA,cDvHe;ECwHf,SAAA;AAZR;AAiBI;EACI,qBAAA;EACA,cD5Ie;EC6If,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AAfR;AAiBQ;EACI,0BAAA;AAfZ;AAmBI;EACI,qBAAA;EACA,cD1Je;EC2Jf,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AAjBR;AAmBQ;EACI,0BAAA;AAjBZ;AAqBI;EAEI,gBAAA;EACA,YAAA;EACA,cD1Ke;EC2Kf,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AApBR;AAsBQ;EACI,0BAAA;AApBZ;;AAyBA;EACI,gBAAA;AAtBJ;;AA0BI;EACI,eAAA;EACA,gBAAA;EACA,cDlLe;ECmLf,kBAAA;AAvBR;AAyBQ;EACI,kBAAA;EACA,6BDrLW;ECsLX,YAAA;AAvBZ;AA2BI;EACI,eAAA;EACA,gBAAA;EACA,cD5Me;EC6Mf,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;AAzBR;;AA8BI;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;AA3BR;AA6BQ;EACI,qBDjOW;ECkOX,8CAAA;AA3BZ;AA+BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA7BR;AAgCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA9BR;AAiCI;EACI,eAAA;EACA,gBAAA;EACA,cDtPe;ECuPf,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA/BR;AAkCI;EACI,mBD/Pe;ECgQf,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAhCR;AAmCI;EACI,gBAAA;EACA,YAAA;EACA,6BD5Pe;EC6Pf,gBAAA;EACA,kBAAA;EACA,eAAA;AAjCR;;AAqCA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCJ;AAoCI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAlCR;AAqCI;EACI,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;AAnCR;AAsCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;AApCR;AAuCI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AArCR;AAwCI;EACI,eAAA;EACA,cD3Te;EC4Tf,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAtCR;;AA0CA;EACI,WAAA;AAvCJ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-primary: $color-primary;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-border: $color-border;\n$bw-surface: $color-surface;\n$bw-radius-xl: $radius-xl;\n$bw-shadow: $shadow-card;\n\n.booking {\n    width: 100%;\n    max-width: 1100px;\n    font-family: \"Sora\", sans-serif;\n    color: $bw-text;\n\n    &__info-column {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n        transition: transform 0.2s ease;\n\n        &:hover {\n            transform: translateY(-1px);\n        }\n    }\n\n    &__header {\n        margin-bottom: 28px;\n    }\n\n    &__sidebar {\n        // background: $bw-surface;\n        // border: 1px solid $bw-border;\n        // border-radius: $bw-radius-xl;\n        // padding: 32px;\n        // box-shadow: $bw-shadow;\n        // transition: transform 0.2s ease;\n\n        &:hover {\n            transform: translateY(-1px);\n        }\n    }\n\n    &__eyebrow {\n        display: inline-block;\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: .16em;\n        text-transform: uppercase;\n        color: $bw-primary;\n        margin-bottom: 8px;\n    }\n\n    &__title {\n        font-size: 24px;\n        font-weight: 800;\n        letter-spacing: -0.04em;\n        margin: 0;\n    }\n\n    &__subtitle {\n        font-size: 16px;\n        color: $bw-muted;\n        margin-top: 8px;\n    }\n\n    &__divider {\n        height: 1px;\n        background-color: $bw-border;\n        border: none;\n        margin: 32px 0;\n    }\n\n    &__grid {\n        display: grid;\n        grid-template-columns: 1fr 340px;\n        gap: 24px;\n\n        @media (max-width: 992px) {\n            grid-template-columns: 1fr;\n        }\n    }\n\n    &__card {\n        background: $bw-surface;\n        border: 1px solid $bw-border;\n        border-radius: $bw-radius-xl;\n        padding: 32px;\n        box-shadow: $bw-shadow;\n        height: 420px;\n\n        @media (max-width: 992px) {\n            height: auto;\n        }\n    }\n\n    &__reminder {\n        display: flex;\n        gap: 12px;\n        padding: 16px 20px;\n        background: rgba(130, 177, 148, 0.1);\n        border: 1px solid rgba(130, 177, 148, 0.24);\n        border-radius: 16px;\n        color: #32453b;\n        font-size: 14px;\n        line-height: 1.5;\n        font-weight: 600;\n        margin-bottom: 24px;\n        align-items: center;\n\n        svg {\n            color: $bw-primary;\n            flex-shrink: 0;\n        }\n    }\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n\n    @media (max-width: 600px) {\n        grid-template-columns: 1fr;\n    }\n}\n\n.info-item {\n    &__label {\n        display: block;\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: .08em;\n        text-transform: uppercase;\n        color: #6B8277;\n        margin-bottom: 8px;\n    }\n\n\n    &__value {\n        font-size: 16px;\n        font-weight: 600;\n        color: $bw-text;\n        margin: 0;\n    }\n\n\n\n    &__view-btn {\n        text-decoration: none;\n        color: $bw-primary;\n        font-size: 13px;\n        font-weight: 800;\n        cursor: pointer;\n        padding: 0;\n        margin-top: 4px;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n\n    &__more-btn {\n        text-decoration: none;\n        color: $bw-primary;\n        font-size: 13px;\n        font-weight: 800;\n        cursor: pointer;\n        padding: 0;\n        margin-top: 4px;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n\n    &__view-btn,\n    &__more-btn {\n        background: none;\n        border: none;\n        color: $bw-primary;\n        font-size: 13px;\n        font-weight: 800;\n        cursor: pointer;\n        padding: 0;\n        margin-top: 4px;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n\n.notes-section {\n    margin-top: 24px;\n}\n\n.notes-display {\n    &__text {\n        font-size: 15px;\n        line-height: 1.6;\n        color: $bw-text;\n        margin-bottom: 8px;\n\n        &--empty {\n            font-style: italic;\n            color: $bw-muted;\n            opacity: 0.7;\n        }\n    }\n\n    &__edit {\n        font-size: 13px;\n        font-weight: 800;\n        color: $bw-primary;\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 0;\n        text-decoration: underline;\n    }\n}\n\n.notes-editor {\n    &__input {\n        width: 100%;\n        min-height: 120px;\n        padding: 16px;\n        border-radius: 16px;\n        border: 1px solid $bw-border;\n        font-family: inherit;\n        font-size: 14px;\n        outline: none;\n\n        &:focus {\n            border-color: $bw-primary;\n            box-shadow: 0 0 0 3px rgba($bw-primary, 0.1);\n        }\n    }\n\n    &__buttons {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    &__actions {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 12px;\n    }\n\n    &__meet {\n        font-size: 13px;\n        font-weight: 800;\n        color: $bw-primary;\n        background: #fff;\n        border: 1px solid $bw-primary;\n        padding: 6px 12px;\n        border-radius: 10px;\n        cursor: pointer;\n    }\n\n    &__btn--save {\n        background: $bw-primary;\n        color: #fff;\n        border: none;\n        padding: 8px 20px;\n        border-radius: 12px;\n        font-weight: 800;\n        cursor: pointer;\n    }\n\n    &__btn--cancel {\n        background: none;\n        border: none;\n        color: $bw-muted;\n        font-weight: 700;\n        margin-right: 12px;\n        cursor: pointer;\n    }\n}\n\n.professional-card {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &__info {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    &__avatar-frame {\n        width: 176px;\n        aspect-ratio: 4 / 5;\n        border-radius: 30px;\n        padding: 6px;\n        background: #FFFFFF;\n        box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);\n        margin-bottom: 20px;\n        position: relative;\n    }\n\n    &__img-container {\n        width: 100%;\n        height: 100%;\n        border-radius: 24px;\n        overflow: hidden;\n        background-color: #F1EEE8;\n        background-size: cover;\n        background-position: center;\n    }\n\n    &__name {\n        font-size: 22px;\n        font-weight: 800;\n        margin: 0;\n    }\n\n    &__specialty {\n        font-size: 14px;\n        color: $bw-primary;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n        margin: 4px 0 24px;\n    }\n}\n\n.booking__status-wrapper {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"booking": `BookingDetailsContent_booking__d6Btn`,
	"booking__info-column": `BookingDetailsContent_booking__info-column__uo8pZ`,
	"booking__header": `BookingDetailsContent_booking__header__roH01`,
	"booking__sidebar": `BookingDetailsContent_booking__sidebar__OKSJS`,
	"booking__eyebrow": `BookingDetailsContent_booking__eyebrow__VflTP`,
	"booking__title": `BookingDetailsContent_booking__title__ABCbI`,
	"booking__subtitle": `BookingDetailsContent_booking__subtitle__ciDr6`,
	"booking__divider": `BookingDetailsContent_booking__divider__M9jWO`,
	"booking__grid": `BookingDetailsContent_booking__grid__N5fdQ`,
	"booking__card": `BookingDetailsContent_booking__card__n4DAl`,
	"booking__reminder": `BookingDetailsContent_booking__reminder__lehol`,
	"info-grid": `BookingDetailsContent_info-grid__gkJOS`,
	"info-item__label": `BookingDetailsContent_info-item__label__PRvfR`,
	"info-item__value": `BookingDetailsContent_info-item__value__ABMVR`,
	"info-item__view-btn": `BookingDetailsContent_info-item__view-btn__Z0eII`,
	"info-item__more-btn": `BookingDetailsContent_info-item__more-btn__wh3ka`,
	"notes-section": `BookingDetailsContent_notes-section__YJvcF`,
	"notes-display__text": `BookingDetailsContent_notes-display__text__qiYQs`,
	"notes-display__text--empty": `BookingDetailsContent_notes-display__text--empty__AK1TB`,
	"notes-display__edit": `BookingDetailsContent_notes-display__edit__YO3OC`,
	"notes-editor__input": `BookingDetailsContent_notes-editor__input__4+Rha`,
	"notes-editor__buttons": `BookingDetailsContent_notes-editor__buttons__FCK5x`,
	"notes-editor__actions": `BookingDetailsContent_notes-editor__actions__tJG5Q`,
	"notes-editor__meet": `BookingDetailsContent_notes-editor__meet__bqhyk`,
	"notes-editor__btn--save": `BookingDetailsContent_notes-editor__btn--save__3jK9o`,
	"notes-editor__btn--cancel": `BookingDetailsContent_notes-editor__btn--cancel__TxKBH`,
	"professional-card": `BookingDetailsContent_professional-card__6WhhS`,
	"professional-card__info": `BookingDetailsContent_professional-card__info__9hzjO`,
	"professional-card__avatar-frame": `BookingDetailsContent_professional-card__avatar-frame__+YgZd`,
	"professional-card__img-container": `BookingDetailsContent_professional-card__img-container__it2c-`,
	"professional-card__name": `BookingDetailsContent_professional-card__name__GRuAn`,
	"professional-card__specialty": `BookingDetailsContent_professional-card__specialty__hFaPC`,
	"booking__status-wrapper": `BookingDetailsContent_booking__status-wrapper__x1r4m`
};
export default ___CSS_LOADER_EXPORT___;
